module.exports = __webpack_public_path__ + "img/pic_deposit_success_yellow@2x.5cb24d8e.png";